import { Injectable } from '@angular/core';
import { isNil, reject } from 'lodash-es';

import { TaskOutput } from 'task/model/task.output';
import { TaskType } from 'task/model/task.type';
import { TaskConverterPort } from 'task/port/task-converter.port';
import { Task } from 'task/task';

@Injectable()
export class TaskConverterAdapter implements TaskConverterPort {
	public taskAsEntity(output: TaskOutput): Task {
		if (!output) {
			return null;
		}

		return new Task(
			output.id,
			output.done,
			output.type,
			new Date(output.dueTimestamp),
			output.owner.id,
			output.modulesId || [],
			output.todoTitle,
			output.contact?.id,
			output.jobOffer?.id,
			(output.participants || []).map((participant) => participant.id),
			output.todoDescription,
			output.updateTimestamp,
			output.externalEventId,
			output.externalEventTitle
		);
	}

	public tasksAsEntities(outputs: TaskOutput[]): Task[] {
		return reject(outputs, isNil).map((output) => this.taskAsEntity(output));
	}
}
